import { render } from "./AllQuestions.vue?vue&type=template&id=b80c1322"
import script from "./AllQuestions.vue?vue&type=script&lang=js"
export * from "./AllQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__